// Vue component rendering a DatasetDistributionGroup and all the contained distributions within
<template>
    <div class="group-panel">
        <div v-if="group.dsName">
            <div class="panel panel-body">
                <h3>
                    <span> {{ group.dsName }} </span>
                    <a v-if="!isRoot" class="pull-right dataset-link" :href="objectUrl + group.dsId" target="_blank">
                        <i class="fal fa-external-link" title="Open data set in new tab" />
                    </a>
                </h3>
                <p v-if="!isRoot" v-html="group.dsDefinition" />
            </div>
            <div v-if="group.name !== 'Root'" class="panel panel-body">
                <h4> {{ group.name }} </h4>
                <p v-html="group.description" />
            </div>
        </div>
        <div v-else>
            <div v-if="group.name !== 'Root'" class="panel panel-body">
                <h3> {{ group.name }} </h3>
                <p v-html="group.description" />
            </div>
        </div>

        <div class="panel panel-body group-table">
            <!-- Subgroups Table -->
            <div v-if="group.groups.length > 0">
                <table class="table table-striped">
                    <thead>
                        <th class="name-column-width">
                            Group Name
                        </th>
                        <th class="definition-width">
                            Definition
                        </th>
                        <th title='Groups' class="count-width">
                            <span class="pull-right">
                                <i class="fa fa-folder" title="Number of Groups (#)" />
                            </span>
                        </th>
                        <th title='Data Set Count' class="count-width">
                            <span class="pull-right">
                                <i class="fa fa-database" title="Number of Data Sets (#)" />
                            </span>
                        </th>
                        <th title='Distribution Count' class="count-width">
                            <span class="pull-right">
                                <i class="fa fa-file" title="Number of Distributions (#)" />
                            </span>
                        </th>
                    </thead>
                    <tbody class="rounded-corners">
                        <tr v-for="subgroup in group.groups" :key="subgroup.id">
                            <td class="name-column-width">
                                <span> <a @click="selectGroup(subgroup)"> {{ subgroup.name }} </a></span>
                            </td>
                            <td class="definition-width" v-html="getDefaultContent(subgroup.description)" />
                            <td class="count-width" :title="subgroup.groups.length + ' Groups'">
                                <span class="pull-right">
                                    {{ getDefaultContent(subgroup.groups.length) }}
                                </span>
                            </td>
                            <td class="count-width" :title="subgroup.datasets.length + ' Data Sets'">
                                <span class="pull-right">
                                    {{ getDefaultContent(subgroup.datasets.length) }}
                                </span>
                            </td>
                            <td class="count-width" :title="subgroup.distributions.length + ' Distributions'">
                                <span class="pull-right">
                                    {{ getDefaultContent(subgroup.distributions.length) }}
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <!-- Included Datasets List -->
            <h4 v-if="group.datasets.length > 0">
                Datasets
            </h4>
            <div v-for="ds in ordered(group.datasets)" :key="ds.uuid">
                <keep-alive>
                    {{ ds }}
                    <nested-dataset-display :dataset="ds" />
                </keep-alive>
            </div>
            <!-- Distributions List -->
            <h4 v-if="group.distributions.length > 0">
                Distributions
            </h4>
            <div v-for="dist in ordered(group.distributions)" :key="dist.uuid">
                <keep-alive>
                    {{ dist }}
                    <nested-distribution-display :distribution="dist" />
                </keep-alive>
            </div>
        </div>
    </div>
</template>

<script>
import NestedDistributionDisplay from "src/components/dataset/components/NestedDistributionDisplay.vue";
import NestedDatasetDisplay from "src/components/dataset/components/NestedDatasetDisplay.vue";

export default {
    name: "DatasetDistributionGroup",
    components: {
        NestedDistributionDisplay,
        NestedDatasetDisplay,
    },
    props: {
        // The DatasetDistributionGroup which is rendered by this component
        group: {
            type: Object,
            required: true,
        },
        isRoot: {
            type: Boolean,
            required: true
        }
    },
    data: () => ({
        objectUrl: '/item/'
    }),
    methods: {
        selectGroup: function(group) {
            this.$emit("selectGroup", group)
        },
        getDefaultContent(content) {
            return content ? content : "-"
        },
        ordered: function(list) {
            return list.toSorted((a, b) => a.order - b.order);
        }
    },
};
</script>

<style scoped>
a {
    cursor: pointer;
}

table tbody.rounded-corners {
    border-collapse: separate;
    border-radius: 6px;
    border: thin lightgrey solid;
    padding-top: 3px;
    padding: 1px;
}

.group-panel {
    margin-bottom: 0px;
    height: 100%;
    /* max-height: 800px; */
}

.name-column-width {
    width: 39%;
}

.definition-width {
    width: 55%;
}

.count-width {
    width: 3;
}

.group-table {
    padding-bottom: 10px;
}

.dataset-link {
    margin-right: 16px;
}
</style>
